<template>
    <div v-if="user"> <!-- v-touch:swipe.left="swipeLeftHandler"  v-touch:swipe.right="swipeRightHandler" -->
        
        <div class="container" v-if="user.data">

            <div class="row justify-content-center" v-if="action !== 'create'">

                <!-- Push subscription message -->
                <div class="col card shadow p-3 mb-5 bg-secondary rounded mt-4" v-if="user.subscription && user.subscription.tier === 0">

                    <div class="card-body">

                        <div class="row">

                            <div class="col-12">
                                <subscriptions :required-license="1" :current-license="user.subscription" />
                            </div>

                        </div>

                    </div>

                </div>

                <div class="col card shadow p-3 mb-5 bg-secondary rounded mt-4" v-else>

                    <div class="card-body">

                        <div class="float-right" v-if="licenseCheck && memberLicenseCheck">
                            <a class="btn btn-sm btn-default text-white" role="button" @click="action = 'create'">
                                <i class="fad fa-users-medical"></i> New Group
                            </a>
                        </div>

                        <h5 class="card-title text-default font-weight-bold">Manage Groups</h5>

                        <ul class="list-group"  v-if="mygroups.length > 0">

                            <li class="list-group-item" v-for="(group,g) in mygroups" v-bind:key="g">

                                <div class="float-right" v-if="view === g">

                                    <a class="btn btn-sm btn-secondary" role="button" @click="setAction('edit')">
                                        <i class="fal fa-pencil"></i> <span class="d-none d-sm-inline">Edit</span>
                                    </a>
                                    <a class="btn btn-sm btn-secondary" role="button" @click="setAction('delete')">
                                        <i class="fal fa-trash"></i> <span class="d-none d-sm-inline">Delete</span>
                                    </a>

                                </div>

                                <div class="font-weight-bold text-default pointer" @click="viewGroup(g)">
                                    <a role="button">

                                        <span class="fa-stack" v-if="group.groupType === 'open'">
                                            <i class="fas fa-square fa-stack-2x"></i>
                                            <i class="fad fa-users fa-stack-1x fa-inverse"></i>
                                        </span>
                                        <span class="fa-stack" v-else>
                                            <i class="fas fa-square fa-stack-2x"></i>
                                            <i class="fad fa-chart-network fa-stack-1x fa-inverse"></i>
                                        </span>

                                        <span class="mt-4 pt-2">{{ group.groupName }}</span>

                                    </a>
                                </div>

                                <div class="card card-body bg-default mt-2" v-if="view === g">

                                    <div class="container">

                                        <div class="row">

                                            <div class="col-lg-8 col-12">

                                                <h6 class="font-weight-bold small text-white"><i class="fad fa-users"></i> Group Members</h6>
                                                <ul class="list-group list-group-flush">
                                                    <li class="list-group-item list-group-item-primary m-0 p-1" v-for="(member,m) in group.members" v-bind:key="m">
                                                        <div class="float-right" v-if="member.roleId !== 3">
                                                            <!-- <a class="btn btn-sm btn-default text-white" role="button" title="edit member" @click="action = 'edit'">
                                                                <i class="fal fa-pencil"></i>
                                                            </a> -->
                                                            <a class="btn btn-sm btn-default text-white" role="button" title="delete member" @click="showDeleteModule(member)">
                                                                <i class="fal fa-trash"></i>
                                                            </a>
                                                        </div>
                                                        <i class="fad fa-crown ml-1 mr-1" :title="member.roleName" v-if="member.roleId === 3"></i>
                                                        <i class="fad fa-user ml-1 mr-1" :title="member.roleName" v-else></i>
                                                        <small>{{ member.fullName }}<!-- [ {{ member.uid }} ] --></small>
                                                    </li>
                                                </ul>

                                                <div>
                                                    <div class="float-right small text-white" v-if="memberLicenseCheck">
                                                        <a role="button" class="pointer" @click="showInviteForm = true" v-if="!showInviteForm">
                                                            <i class="fal fa-plus"></i> <span class="d-none d-sm-inline">new invitations</span>
                                                        </a>
                                                        <a role="button" class="pointer" @click="showInviteForm = false" v-else>
                                                            <i class="fal fa-times"></i> <span class="d-none d-sm-inline">cancel</span>
                                                        </a>
                                                    </div>
                                                    <h6 class="font-weight-bold small text-white mt-4"><i class="fad fa-mail-bulk"></i> Invitations</h6>
                                                </div>
                                                <div class="form-row mb-1" v-if="memberLicenseCheck && showInviteForm">
                                                    <div class="col-sm-9 my-1">
                                                        <input type="input" placeholder="Add a new email" v-model="tempInvite" class="form-control">
                                                    </div>
                                                    <div class="col-sm-3 my-1">
                                                        <button class="btn btn-secondary btn-block" type="button" @click="commitInvite" v-if="validEmail(tempInvite)"><i class="fal fa-envelope"></i> Add</button>
                                                        <button class="btn btn-secondary btn-block" disabled type="button" v-else><i class="fal fa-envelope"></i> Add</button>
                                                    </div>
                                                </div>
                                                <ul class="list-group list-group-flush mb-4" v-if="group.invitations.length > 0">
                                                    <li class="list-group-item list-group-item-primary m-0 p-1" v-for="(invitee,m) in group.invitations" v-bind:key="m">
                                                        <div class="float-right">
                                                            <a class="btn btn-sm btn-default text-white" role="button" title="resend invitation" @click="resendInvite(group,invitee.email)" v-show="!inviteResent(group.id,invitee.email)">
                                                                <i class="fal fa-repeat"></i>
                                                            </a>
                                                            <a class="btn btn-sm btn-default text-white" role="button" title="delete invitation" @click="deleteInvite(m)">
                                                                <i class="fal fa-trash"></i>
                                                            </a>
                                                        </div>
                                                        <small>{{ invitee.email }}</small>
                                                    </li>
                                                </ul>

                                            </div>

                                            <div class="col-lg-4 col-12 text-white">
                                                <h6 class="font-weight-bold small text-white"><i class="fas fa-tag"></i> Tags</h6>
                                                <ul class="list-group list-group-flush" v-if="group.tags.length > 0">
                                                    <li class="list-group-item list-group-item-primary m-0 p-1" v-for="(tag,index) in group.tags" v-bind:key="index">
                                                        <small>{{ tag.name }}</small>
                                                    </li>
                                                </ul>
                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </li>

                        </ul>

                        <div v-if="mygroups.length === 0 && licenseCheck && memberLicenseCheck">

                            <p class="mb-4">You currently have no groups!</p>

                            <a class="btn btn-default text-white" role="button" @click="action = 'create'">
                                <i class="fad fa-users-medical"></i> Create your first group now!
                            </a>

                        </div>

                    </div>

                </div>

            </div>

            <div class="card-body" v-show="action">

                <div v-show="action === 'create'">
                    <group-create :user="user" :groups="groups" :licensesUsed="licensesUsed" v-on:receiveInvites="processInvites"  v-on:cancelParentCreate="modalWasClosed"></group-create>
                </div>

            </div>

            <div v-if="action && action != 'create'">
                <group-modals :entry="entry" :member="selectedMember" :action="action" v-on:modalClosed="modalWasClosed"></group-modals>
            </div>

            <div class="text-center text-muted small" v-if="user.subscription.tier > 0">
                <b>License Details</b><br>
                {{ licensesUsed }} of {{ user.subscription.maxUsers }} Total Users | {{ mygroups.length }} of {{ user.subscription.maxGroups }} Groups
            </div>

        </div>

        <div class="container" v-else>

            <div class="row justify-content-center mt-4">
                <div class="col-8 text-center">

                    <div class="alert alert-default">
                        
                        <i class="fad fa-spinner-third fa-4x fa-spin"></i>
                        <h5 class="text-white mt-2">Grabbing your groups</h5>

                    </div>

                </div>

            </div>

        </div>
       
    </div>
</template>
<script>

const Subscriptions = () => import('@/components/billing/Subscriptions');
const GroupCreate = () => import('@/components/managegroups/Create');
const GroupModals = () => import('@/components/managegroups/Modals');
// import Subscriptions from "@/components/billing/Subscriptions";
// import GroupCreate from "@/components/managegroups/Create";
// import GroupModals from  "@/components/managegroups/Modals";

import BaseDropdown from "@/components/BaseDropdown";

import firebase from 'firebase/app'
import { db } from '@/firebase';
import store from '@/store.js'
import { mapGetters } from "vuex";

// const currentUser = firebase.auth().currentUser;

export default {
    name: 'mygroups',
    metaInfo: {
      title: 'Manage Groups',
    },
    components: {
        Subscriptions,
        GroupCreate,
        GroupModals,
        BaseDropdown,
        // 'b-collapse': BCollapse
    },

    data() {
      return {
        mygroups: [],
        action: null,
        entry: null,
        selectedMember: null,
        view: null,
        resent: [],
        tempInvite: null,
        licensesUsed: 0,
        showInviteForm: false,
        plans:[]
      }
    },

    mounted() {
        this.checkMembers()
    },

    watch: {

        mygroups() {
            this.checkMembers()
        }

    },

    computed: {

        ...mapGetters({
            // map `this.user` to `this.$store.getters.user`
            // map `this.groups` to `this.$store.getters.groups`
            user: "user",
            groups: "groups"
        }),

        subscription(){

            if(this.user.subscription){

                if(this.user.subscription.status === 1){
                    return this.user.subscription
                }
                
            }

            return { tier: 0, name:'free' }

        },

        licenseCheck(){

            if(!this.mygroups){
                return false
            }

            if(this.user.subscription.maxGroups > this.mygroups.length){
                return true
            }

            return false

        },

        memberLicenseCheck(){

            if(!this.mygroups){
                return false
            }

            if(this.user.subscription.maxUsers > this.licensesUsed){
                return true
            }

            return false

        }

    },

    methods: {

        setAction(action){

            this.action = null
            setTimeout(this.setActionDelayed(action),2000)

        },

        setActionDelayed(action){
            this.action = action
        },

        showDeleteModule(member){
            this.selectedMember = member
            this.action = 'deletemember'
        },

        checkMembers(){

            let memberCount = 0

            let mygroups = this.mygroups

            mygroups.forEach((group) => {
                memberCount += ( group.invitations.length + (group.members.length-1) )
            })

            this.licensesUsed = memberCount

            if(memberCount === 0){
                return
            }

            // Store the number of used licenses on the owners record
            if(!this.user.data.subscriptionDetails || !this.user.data.subscriptionDetails.usedLicenses || this.user.data.subscriptionDetails.usedLicenses != memberCount){

                let newUser = JSON.parse(JSON.stringify(this.user.data));

                if(!newUser.subscriptionDetails){
                    newUser.subscriptionDetails = { usedLicenses: 0 }
                }

                newUser.subscriptionDetails.usedLicenses = memberCount
                this.$store.dispatch("updateUser", newUser);

            }

        },

        validEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },

        viewGroup(index){

            this.entry = this.mygroups[index];

            if(index === this.view){
                this.view = null
            }else{
                this.view = index
            }

        },

        processInvites(params){

            let subject = params.subject
            let group = params.group
            let invitations = params.invitations

            this.createInvitations(subject,group,invitations)

        },

        resendInvite(group,invite){

            let subject = 'Another invitation to ' + group.groupName + ' @ myreflections.app'
            let invitations = [{ email: invite, status: 'resend' }]

            this.resent.push({ groupId: group.id,email:invite })
            this.createInvitations(subject,group,invitations)

        },

        deleteInvite(index){

            this.entry.invitations.splice(index, 1);
            this.updateGroup(this.entry)

        },

        commitInvite(){

            if(this.tempInvite){

                let invite = { 'email': this.tempInvite, 'status':'pending' }
                
                this.entry.invitations.push(invite)
                this.updateGroup(this.entry)

                let subject = 'Invitation to ' + this.entry.groupName + ' @ myreflections.app'

                let invitations = [invite]
                this.createInvitations(subject,this.entry,invitations)

                this.tempInvite = ''

            }

        },

        updateGroup(group){

            db.collection("groups").doc(group.id).update(group);

        },

        createInvitations(subject,group,invites){

            const vm = this;

            var batch = db.batch();
            let groupId = group.id

            let invitations = invites

            let message = 'You have been invited to ' + group.groupName + ' @ My Reflections'
            let cta = ''
            let btn_text = 'Accept Invite'
            let cta_text = ''

            invitations.forEach((doc) => {

                var docRef = db.collection("mail").doc();

                cta = 'https://www.myreflections.app/invite/' + groupId + '/' + docRef.id
                cta_text = '\n\nClick here to review and accept\n' + cta

                let mail = {
                    from: 'My Reflections <noreply@myreflections.app>',
                    to: [ doc.email ],
                    message: {
                        subject: subject,
                        text: message + cta_text,
                        html: '<!DOCTYPE html><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head><title></title> <!--[if !mso]><!-- --><meta http-equiv="X-UA-Compatible" content="IE=edge"> <!--<![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1"><style type="text/css">#outlook a{padding:0}.ReadMsgBody{width:100%}.ExternalClass{width:100%}.ExternalClass *{line-height:100%}body{margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}table,td{border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt}img{border:0;height:auto;line-height:100%;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic}p{display:block;margin:13px 0}</style><!--[if !mso]><!--><style type="text/css">@media only screen and (max-width:480px){@-ms-viewport{width:320px}@viewport{width:320px}}</style><!--<![endif]--> <!--[if mso]> <xml> <o:OfficeDocumentSettings> <o:AllowPNG/> <o:PixelsPerInch>96</o:PixelsPerInch> </o:OfficeDocumentSettings> </xml> <![endif]--> <!--[if lte mso 11]><style type="text/css">.outlook-group-fix{width:100% !important}</style><![endif]--> <!--[if !mso]><!--><link href="https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700" rel="stylesheet" type="text/css"><link href="https://fonts.googleapis.com/css?family=Cabin:400,700" rel="stylesheet" type="text/css"><style type="text/css">@import url(https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700);@import url(https://fonts.googleapis.com/css?family=Cabin:400,700);</style><!--<![endif]--><style type="text/css">@media only screen and (min-width:480px){.mj-column-per-100{width:100% !important;max-width:100%}}</style><style type="text/css">@media only screen and (max-width:480px){table.full-width-mobile{width:100% !important}td.full-width-mobile{width:auto !important}}</style><style type="text/css">.hide_on_mobile{display:none !important}@media only screen and (min-width: 480px){.hide_on_mobile{display:block !important}}.hide_section_on_mobile{display:none !important}@media only screen and (min-width: 480px){.hide_section_on_mobile{display:table !important}}.hide_on_desktop{display:block !important}@media only screen and (min-width: 480px){.hide_on_desktop{display:none !important}}.hide_section_on_desktop{display:table !important}@media only screen and (min-width: 480px){.hide_section_on_desktop{display:none !important}}[owa] .mj-column-per-100{width:100%!important}[owa] .mj-column-per-50{width:50%!important}[owa] .mj-column-per-33{width:33.333333333333336%!important}p{margin:0px}@media only print and (min-width:480px){.mj-column-per-100{width:100%!important}.mj-column-per-40{width:40%!important}.mj-column-per-60{width:60%!important}.mj-column-per-50{width:50%!important}mj-column-per-33{width:33.333333333333336%!important}}</style></head><body style="background-color:#FFFFFF;"><div style="background-color:#FFFFFF;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#8D6C9F;background-color:#8D6C9F;width:100%;"><tbody><tr><td> <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"> <![endif]--><div style="Margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;vertical-align:top;"> <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" > <![endif]--><div class="mj-column-per-100 outlook-group-fix" style="font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tbody><tr><td align="center" style="font-size:0px;padding:15px 15px 15px 15px;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:210px;"><img alt="My Reflections" height="auto" src="https://firebasestorage.googleapis.com/v0/b/my-reflection-22932.appspot.com/o/FCMImages%2Fhor-white-nobrain-w350.png?alt=media&amp;token=445697bf-37e1-4302-a3ca-70fee26df5ad" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="210"></td></tr></tbody></table></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table> <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"> <![endif]--><div style="background:#FFFFFF;background-color:#FFFFFF;Margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#FFFFFF;background-color:#FFFFFF;width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:9px 0px 9px 0px;text-align:center;vertical-align:top;"> <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" > <![endif]--><div class="mj-column-per-100 outlook-group-fix" style="font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tbody><tr><td align="center" style="font-size:0px;padding:0px 20px 0px 20px;word-break:break-word;"><div style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:11px;line-height:1.5;text-align:center;color:#000000;"><h3 style="font-family: &apos;Cabin&apos;, sans-serif; font-size: 20px; color: #555555; line-height: 100%;">' + subject + '</h3></div></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"> <![endif]--><div style="background:#FFFFFF;background-color:#FFFFFF;Margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#FFFFFF;background-color:#FFFFFF;width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:9px 0px 9px 0px;text-align:center;vertical-align:top;"> <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" > <![endif]--><div class="mj-column-per-100 outlook-group-fix" style="font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tbody><tr><td align="left" style="font-size:0px;padding:15px 15px 15px 15px;word-break:break-word;"><div style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:11px;line-height:1.5;text-align:left;color:#000000;"><p style="text-align: center;"><span style="font-size: 16px;">' + message + '</span></p></div></td></tr><tr><td align="center" vertical-align="middle" style="font-size:0px;padding:15px 15px 15px 15px;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;width:auto;line-height:100%;"><tbody><tr><td align="center" bgcolor="#8D6C9F" role="presentation" style="border:none;border-radius:0px;cursor:auto;mso-padding-alt:10px 30px 10px 30px;background:#8D6C9F;" valign="middle"> <a href="' + cta + '" style="display:inline-block;background:#8D6C9F;color:#ffffff;font-family:Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif;font-size:15px;font-weight:normal;line-height:100%;Margin:0;text-decoration:none;text-transform:none;padding:10px 30px 10px 30px;mso-padding-alt:0px;border-radius:0px;" target="_blank">' + btn_text + '</a></td></tr></tbody></table></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td> <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"> <![endif]--><div style="Margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:9px 0px 9px 0px;text-align:center;vertical-align:top;"> <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" > <![endif]--><div class="mj-column-per-100 outlook-group-fix" style="font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tbody><tr><td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;"> <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" ><tr><td> <![endif]--><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;"><tbody><tr><td style="padding:4px;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border-radius:3px;width:35px;"><tbody><tr><td style="font-size:0;height:35px;vertical-align:middle;width:35px;"> <a href="https://www.facebook.com/myreflectionsapp" target="_blank"> <img height="35" src="https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/facebook.png" style="border-radius:3px;display:block;" width="35"> </a></td></tr></tbody></table></td></tr></tbody></table> <!--[if mso | IE]></td><td> <![endif]--><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;"><tbody><tr><td style="padding:4px;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border-radius:3px;width:35px;"><tbody><tr><td style="font-size:0;height:35px;vertical-align:middle;width:35px;"> <a href="https://www.twitter.com/myreflections20" target="_blank"> <img height="35" src="https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/twitter.png" style="border-radius:3px;display:block;" width="35"> </a></td></tr></tbody></table></td></tr></tbody></table> <!--[if mso | IE]></td><td> <![endif]--><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;"><tbody><tr><td style="padding:4px;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border-radius:3px;width:35px;"><tbody><tr><td style="font-size:0;height:35px;vertical-align:middle;width:35px;"> <a href="https://www.instagram.com/myreflectionsapp/" target="_blank"> <img height="35" src="https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/instagram.png" style="border-radius:3px;display:block;" width="35"> </a></td></tr></tbody></table></td></tr></tbody></table> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr><tr><td style="font-size:0px;padding:10px 25px;padding-top:10px;padding-right:100px;padding-bottom:10px;padding-left:100px;word-break:break-word;"><p style="border-top:solid 1px #CCCCCC;font-size:1;margin:0px auto;width:100%;"></p> <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" style="border-top:solid 1px #CCCCCC;font-size:1;margin:0px auto;width:400px;" role="presentation" width="400px" ><tr><td style="height:0;line-height:0;"> &nbsp;</td></tr></table> <![endif]--></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td> <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"> <![endif]--><div style="Margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;vertical-align:top;"> <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" > <![endif]--><div class="mj-column-per-100 outlook-group-fix" style="font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tbody><tr><td align="center" style="font-size:0px;padding:0px 0px 0px 0px;word-break:break-word;"><div style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:15px;line-height:1.5;text-align:center;color:#949494;"><p><span style="font-size: 12px;">Copyright &#xA9; 2020 My Reflections, All rights reserved.&#xA0;<br></span></p></div></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table></div></body></html>'
                    }
                }

                batch.set(docRef, mail);

            })

            // Commit the batch
            batch.commit().then(function () {

                vm.$toast.open({
                    message: 'Invitation(s) Sent!',
                    type: 'success',
                    // all of other options may go here
                });

            });


        },

        inviteResent(groupId,email){

            let alreadyResent = false

            let resends = this.resent
            resends.forEach((doc) => {
                if(doc.groupId === groupId && doc.email === email){
                    alreadyResent = true
                }
            })

            return alreadyResent

        },

        modalWasClosed(){

            this.action = null

        },

        // swipeLeftHandler(){

        //     if(!this.currentWeek && !this.$isDesktop()){
        //         this.$router.replace('profile')
        //     }

        // },

        // swipeRightHandler(){

        //     if(!this.currentWeek && !this.$isDesktop()){
        //         this.$router.replace('reflectnow')
        //     }
            
        // }

    },
    firestore () {
      return {
        mygroups: db.collection('groups').where('ownerId', '==', this.user.data.uid).orderBy('groupName', "asc")
        // groups: db.collection('groups').where('uids', 'array-contains',  this.user.data.uid ).orderBy('groupName', "asc")
      }
    } // 

};
</script>
<style scoped>

.card-ellipse {
    position: absolute;
    text-align: right;
    /* z-index: 10; */
    top: 0;
    right: 0;
}

.img-groups {
    width: 25%; 
    height: 25%;
}

.row-striped:nth-of-type(odd){
  background-color: #efefef;
  /* border-left: 4px #000000 solid; */
}

.row-striped:nth-of-type(even){
  background-color: #ffffff;
  /* border-left: 4px #efefef solid; */
}

.row-striped {
    padding: 15px 0;
}

</style>
